import $ip from'../../../pip/library/pi-ip/pi-ip.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

import { regExp, TConstants, TParameters } from '../types';
import { writeURI, concatenateURI } from '../tools/uri';
import { readQueryParameters, serializeParameters, deserializeParameters } from '../tools/parameters';

/**
 *
 */
export class NavigationURI {
  lens = {};

  /**
   *
   */
  regExp = regExp;

  /**
   * @deprecated use toState
   */
  uriToState(uri: string): string {
    return this.toState(uri);
  }

  /**
   * a uri converts to a state where the following characters are important:
   *
   * - `-` joins paths across parent-child boundaries
   * - `_` joins uri parts at the same state route
   *
   */
  toState(uri?: string): string {
    return (uri || '')
      .replace(this.regExp.matchQueryParameters, '')
      .replace(this.regExp.matchFirstSlash, '')
      .split('/')
      .map(f1.either(f1.noop, f1.identity, f1.is.like(this.regExp.matchWholeWords)))
      .filter(f1.identity)
      .join('-');
  }

  /**
   * if a string is assigned we convert to parameters (deserialize) and if an object, then we serialize
   */
  parameters(parameters: TParameters | string, constants?: TConstants) {
    return typeof parameters === 'string'
      ? this.deserializeParameters(parameters)
      : this.serializeParameters(parameters, constants);
  }

  /**
   * convert a key/value pairs to a dictionary of strings
   *
   * @param uri the uri to collect parameters from
   */
  deserializeParameters(uri: string): TParameters {
    return deserializeParameters(uri);
  }

  /**
   * convert parameters to a safe uri string (append to a uri after `?`)
   *
   * @param parameters a dictionary of keys
   * @param constants additional lookup values for any values in the parameters
   */
  serializeParameters(parameters: TParameters, constants?: TConstants) {
    return serializeParameters(parameters, constants);
  }

  /**
   * return the base of the uri, without parameters
   *
   * @param uri the uri to collect parameters from
   * @see safe.uriBase
   */
  readBase(uri: string): string {
    return uri.split('?')[0] || '';
  }

  /**
   * convert a uri with key/value pairs after `?` in to a dictionary of strings
   *
   * @param uri the uri to collect parameters from
   * @see safe.uriParameters
   */
  readParameters(uri: string): TParameters {
    return readQueryParameters(uri);
  }

  /**
   * build a string of uri to a single safe uri
   * @see safe.concatenateURI
   */
  concatenate(uris: string[]): string {
    return concatenateURI(uris);
  }

  /**
   * write a URI with constants and parameters
   *
   * @param uri the uri to write
   * @param params route or query parameters
   */
  write(uri: string, params?: TParameters) {
    // if we do not get a string then we do not have a valid uri
    // we return '' because other methods will expect a string, but we should not create values
    //
    return typeof uri === 'string' ? writeURI($ip.constants.read(uri), params) : '';
  }
}

export const uriN = new NavigationURI();
